import React from 'react';

import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {ButtonVariant} from 'components/ui-kit/Button';

import {history} from 'core/history';
import {ROUTE} from 'core/routes';

import {UserRoles} from 'types';

import {RecallButton} from '../Controls/styled';

export const RecallControl = () => {
    const {t} = useTranslation();
    return (
        <PermissionAccess
            permissions={[]}
            roleAccess={[
                UserRoles.ROLE_MPL_OPERATOR_ADMIN,
                UserRoles.ROLE_MPL_MANUFACTURER_DIRECTOR,
                UserRoles.ROLE_MPL_MANUFACTURER_EMPLOYEE,
                UserRoles.ROLE_MPL_IMPORTER_DIRECTOR,
                UserRoles.ROLE_MPL_IMPORTER_EMPLOYEE,
            ]}
        >
            <RecallButton
                size="sm"
                variant={ButtonVariant.Secondary}
                onClick={() => {
                    history.push(ROUTE.REGISTRIES_RECALL);
                }}
            >
                {t('pages.registries.recall')}
            </RecallButton>
        </PermissionAccess>
    );
};
